import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loading = ({ loading }) => {
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined
                style={{ fontSize: 50, color: "#F18B6F" }}
                spin
              />
            }
          />
        </div>
      )}
    </>
  );
};

export default Loading;